import { GymSubtype, GymType } from "../constants/gymSubtypes";
import { RevenueHeroClient } from "../types/revenue-hero";
import { useEffect } from "react";

export interface BookDemoFormData {
  email: string;
  firstname?: string;
  lastname?: string;
  company?: string;
  gymType?: string;
  countryName?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
}

export interface SignupFlowFormData {
  companyName: string;
  country: string;
  gymType: GymType;
  gymSubtype: GymSubtype;
  yearsOpen: string;
  monthlyRevenue: string;
  businessNeeds: string;
  currentSoftware: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: number;
  websiteUrl: string;
  utmMedium: string;
  utmSource: string;
  utmCampaign: string;
  utmContent: string;
  utmTerm: string;
}

type RevenueHeroSubmitData = BookDemoFormData | SignupFlowFormData;

export const useRevenueHero = (revenueHeroRouterId: string) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.revenuehero.io/scheduler.min.js";
    script.id = "revenue-hero-scheduler";
    document.body.appendChild(script);

    return () => {
      const revenueHeroScheduler = document.getElementById(
        "revenue-hero-scheduler",
      );
      if (revenueHeroScheduler) {
        document.body.removeChild(revenueHeroScheduler);
      }
    };
  }, []);

  const showScheduler = async <T extends RevenueHeroSubmitData>(
    jsonData: T,
  ) => {
    try {
      const hero: RevenueHeroClient = new window.RevenueHero({
        routerId: revenueHeroRouterId,
      });
      const sessionData = await hero.submit(jsonData);

      if (!sessionData) {
        throw new Error("Unable to book demo - check revenue hero logs");
      }

      hero.dialog.open(sessionData);
    } catch (error) {
      console.error("Scheduler error:", error);
      throw error;
    }
  };

  return { showScheduler };
};
